import React from 'react';

const ProfileAvatar = ({ url, name, className = "h-12 w-12" }) => {
  const getInitials = (name) => {
    if (!name) return 'U';
    const parts = name.trim().split(' ');
    if (parts.length >= 2) {
      return (parts[0][0] + parts[1][0]).toUpperCase();
    }
    return name[0].toUpperCase();
  };

  const initials = getInitials(name);

  return (
    <div
      className={`${className} rounded-full flex items-center justify-center text-white font-semibold bg-blue-500 overflow-hidden`}
      style={{ minWidth: className.includes('w-') ? undefined : '48px' }}
    >
      {url ? (
        <img
          src={url}
          alt={name || 'User'}
          className="w-full h-full object-cover"
          onError={(e) => {
            e.target.style.display = 'none';
            e.target.nextSibling.style.display = 'flex';
          }}
        />
      ) : null}
      <div
        className="w-full h-full flex items-center justify-center bg-blue-500"
        style={{ display: url ? 'none' : 'flex' }}
      >
        {initials}
      </div>
    </div>
  );
};

export default ProfileAvatar;

